module.exports = __webpack_public_path__ + "img/userSVG.896129ac.svg";